import styled from 'styled-components';

import {
  AccountDropdownMenuButton,
  AccountDropdownMenuListItem,
  AccountDropdownMenuList,
  AccountDropdownMenuWrapper,
} from 'layout/header/styles/AccountDropdownMenu';
import { UnorderedList } from 'shared/components/UnorderedList';
import { useSitePreferencesModal } from 'shared/hooks/useSitePreferencesModal';
import { useStoreDispatch } from 'store/hooks/storeHooks';
import {
  openCreateAccountModal,
  openLoginModal,
  setDarkTheme,
} from 'store/slice/accountModalSlice';
import { t } from 'localization/utils/t';
import { useWindowSize } from 'shared/hooks/useWindowSize';

const TP = 'layout.header.components.LoggedOutDropdownMenu';

export const LoggedOutDropdownMenu = () => {
  const storeDispatch = useStoreDispatch();
  const { isMobileOrTablet } = useWindowSize();
  const { openSitePreferencesModal } = useSitePreferencesModal();

  const handleCreateAccountClick = () => {
    storeDispatch(setDarkTheme(isMobileOrTablet));
    storeDispatch(openCreateAccountModal());
  };

  const handleLogInClick = () => {
    storeDispatch(setDarkTheme(isMobileOrTablet));
    storeDispatch(openLoginModal());
  };

  return (
    <LoggedOutDropdownMenu.Wrapper>
      <LoggedOutDropdownMenu.List>
        <LoggedOutDropdownMenu.ListItem>
          <button data-qa="log_in_menu_button" onClick={handleLogInClick} type="button">
            {t(`${TP}.logIn`, 'Log In')}
          </button>
        </LoggedOutDropdownMenu.ListItem>
        <LoggedOutDropdownMenu.ListItem>
          <button
            data-qa="create_account_menu_button"
            onClick={handleCreateAccountClick}
            type="button"
          >
            {t(`${TP}.createAccount`, 'Create Account')}
          </button>
        </LoggedOutDropdownMenu.ListItem>
        <LoggedOutDropdownMenu.ListItem>
          <button
            data-qa="location_preference_menu_button"
            onClick={openSitePreferencesModal}
            type="button"
          >
            {t(`${TP}.locationPreferences`, 'Location Preferences')}
          </button>
        </LoggedOutDropdownMenu.ListItem>
      </LoggedOutDropdownMenu.List>
    </LoggedOutDropdownMenu.Wrapper>
  );
};

LoggedOutDropdownMenu.Wrapper = styled.div`
  ${AccountDropdownMenuWrapper};
`;

LoggedOutDropdownMenu.List = styled(UnorderedList)`
  ${AccountDropdownMenuList}
`;

LoggedOutDropdownMenu.ListItem = styled.li`
  ${AccountDropdownMenuListItem}

  button {
    ${AccountDropdownMenuButton};
    padding-bottom: 6px;
  }
`;
